import React from 'react';
import PropTypes from 'prop-types';

const WveInputAsset = ({ title, value, onClick }) =>
  <div
    className="wve-input-pair wve-form-item wve-form-item-long form-control input-sm p-r-0"
  >
    <p
      className="wve-form-item wve-form-item-long wve-asset-name text-left m-b-0 p-r-10"
      title={title}
    >
      {value}
    </p>
    <button
      type="button"
      className="btn btn-sm wve-p-r-l-6"
      style={{ width: '15%' }}
      onClick={onClick}
    >
      <i className="wve-icon wve-icon-folder" />
    </button>
  </div>;

WveInputAsset.defaultProps = {
  title: '',
};

WveInputAsset.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default WveInputAsset;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputAsset/WveInputAsset.jsx